// Role-based UI permission. NOTE: this is UI filtering only — not security.
// Phase 4 (GAS auth) must enforce permissions server-side.

import { ROLES } from './roles.js';
import { state } from './state.js';

export const PERM = { level: 'coo', buFilter: null };

export function setPerm(key) {
  if (key === 'COO') { PERM.level = 'coo'; PERM.buFilter = null; return; }
  const buMap = { 'CAR-MGR': 'CAR', 'HJ-MGR': 'HJ', 'MKT-MGR': 'MKT' };
  if (buMap[key]) { PERM.level = 'bu_mgr'; PERM.buFilter = buMap[key]; return; }
  const role = ROLES.find((r) => r.key === key);
  const grpBU = { car: 'CAR', hj: 'HJ', mkt: 'MKT' };
  PERM.level = 'specialist';
  PERM.buFilter = role ? grpBU[role.group] : null;
}

/** bu = 'CAR' | 'HELI' | 'JET' */
export function canSeeBU(bu) {
  if (PERM.level === 'coo') return true;
  if (PERM.buFilter === 'HJ') return bu === 'HELI' || bu === 'JET';
  if (PERM.buFilter === 'CAR') return bu === 'CAR';
  return false;
}

export function canSeeRole(rk) {
  if (PERM.level === 'coo') return true;
  const r = ROLES.find((x) => x.key === rk);
  if (!r) return false;
  const grpBU = { car: 'CAR', hj: 'HJ', mkt: 'MKT' };
  if (PERM.level === 'bu_mgr') return grpBU[r.group] === PERM.buFilter;
  return rk === state.selRole; // specialist: only self
}
